


import * as actions from '../actions/index';
import { tabFilters, searchDirections } from '../util/constants'
const initialState = {
  filteredShipments: null,
  page: 1,
  totalBrokerJobs: 0,
  filters: [],
  brokerJobs: [],
  loadingBrokerJobs: true,
  searchTab: "SEARCH_TAB_ETA_DAYS",
  direction: searchDirections.ascending,
  docTypes: [],
  currentJobState: null
};
 
export default function searchContextReducer(state = initialState, action) {
  switch (action.type) {
    case actions.SET_TOTAL_NUMBER_OF_JOBS: {
      return Object.assign({}, state, { totalBrokerJobs: action.value });
    }
    case actions.SET_LOADING_SHIPMENTS: {
      return Object.assign({}, state, { loadingBrokerJobs: action.value });
    }
    case actions.SET_PAGE: {
      return Object.assign({}, state, { page: action.page, loadingBrokerJobs: true });
    }
    case actions.SET_FILTERS: {
      if ((action.filters.length === 0 || action.searchAt === 'all') && window.shipmentCountry!="US") {//removing the searchtab here broke non-US
        return Object.assign({}, state, { searchTab: "", filters: action.filters, shipmentsLoading: true, page: 1 });
      } else {
        return Object.assign({}, state, { filters: action.filters, shipmentsLoading: true, page: 1});
      }
    }
    case actions.SET_TAB: {
      return Object.assign({}, state, { searchTab: action.tab, shipmentsLoading: true, page: 1 });
    }
    case actions.GET_DOCUMENT_TYPES: {
      return Object.assign({}, state, { docTypes: action.documentTypes });
    }
    case actions.SET_DIRECTION: {
      return Object.assign({}, state, { direction: action.direction, shipmentsLoading: true, page: 1 });
    }
    case actions.ADD_NEW_TANSIT_CARD: {
      let brokerJobsData = state.brokerJobs.slice();
      let jobData = insert(brokerJobsData, 0, action.jobData) 
      return Object.assign({}, state, { brokerJobs: jobData, loadingBrokerJobs: false });
    }
    
    case actions.CURRENT_JOB_STATE: {
      if (!action.currentShipmentId) { 
        return state
      }
      if(!state.brokerJobs){
        return state;
      }
      let brokerJobsData = state.brokerJobs.slice();
      let removePSCEnding = (shipmentId)=>{
        shipmentId=shipmentId||"";
        if(shipmentId.includes("--")){
          shipmentId = shipmentId.split("--")[0];
        }
        return shipmentId;
      }
      brokerJobsData.map((item, index)=>{
      if(removePSCEnding(item.shipmentId) === removePSCEnding(action.currentShipmentId)){
          if(action.currentJobData){
            if(brokerJobsData[index]){
              action.currentJobData[0].bol = action.currentJobData[0].bol || brokerJobsData[index].bol;
              action.currentJobData[0].masterBolNumber = action.currentJobData[0].masterBolNumber || brokerJobsData[index].masterBolNumber;
            }
            brokerJobsData[index] = action.currentJobData[0];
          }
        }
      })
      if(!brokerJobsData){
        return state
      }
      // Store globally for validation functions (set once after map completes)
      if(action.currentJobData && action.currentJobData[0]){
        window.currentJobData = action.currentJobData[0];
      }
      // console.log("currentJobData", action.currentJobData[0].states.states[1].value);
      // console.log("brokerJobsData", brokerJobsData[0].states.states[1].value);
      return Object.assign({}, state, { brokerJobs: brokerJobsData, loadingBrokerJobs: false });
    } 
    case actions.SET_BROKER_JOBS: {
      if (!action.value) { //  Search faisl quite often so as to not reset app, do nothing if search failed
        return state
      }
      return Object.assign({}, state, { brokerJobs: action.value, loadingBrokerJobs: false });
    }
    case 'SET_NO_JOBS_FOUND': {
      return Object.assign({}, state, { brokerJobs: null, loadingBrokerJobs: false });
    }
    case actions.UPDATE_DATA: {
      return Object.assign({}, state, { [action.key]: action.value });
    }
    default:
      return state
  }
}

const insert = (arr, index, newItem) => [
  // part of the array before the specified index
  ...arr.slice(0, index),
  // inserted item
  newItem,
  // part of the array after the specified index
  ...arr.slice(index)
]